<template>
  <v-card>
    <v-card-title>
        Editar pergunta
    </v-card-title>
    <v-container flex>
      <v-form lazy-validation v-model="valid" ref="formFaq">
        <v-layout row wrap fill-height justify-space-between>
            <v-flex xs12>
                <v-text-field
                  label="Título"
                  :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                  v-model="dadosPergunta.titulo"
                  required
                >
                </v-text-field>
            </v-flex>
        </v-layout>
            <v-layout row wrap align-center>
                Quem verá:
                <v-spacer></v-spacer>
                <v-checkbox
                    v-model="dadosPergunta.classificacao_posto"
                    label="Posto"
                    color="info"
                    class="shrink mr-3"
                ></v-checkbox>
                <v-checkbox
                    v-model="dadosPergunta.classificacao_cliente"
                    label="Cliente"
                    color="info"
                    class="shrink mr-3"
                ></v-checkbox>
                <v-checkbox
                    v-model="dadosPergunta.classificacao_frentista"
                    label="Frentista"
                    color="info"
                    class="shrink mr-3"
                ></v-checkbox>
                <v-checkbox
                    v-model="dadosPergunta.classificacao_empresa"
                    label="Empresa"
                    color="info"
                    class="shrink mr-3"
                ></v-checkbox>
            </v-layout>
        <v-layout>
            <v-flex xs12>
                <v-textarea
                    v-model="dadosPergunta.conteudo"
                    counter="500"
                    label="Conteúdo"
                    required
                    :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                >
                </v-textarea>
            </v-flex>
        </v-layout>
      </v-form>
    </v-container>
    <v-card-actions>
        <v-btn flat color="info" @click="fechar()">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn flat color="info" @click="atualizarPergunta()">Confirmar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { faqDao } from '@/api'

export default {
  data () {
    return {
      valid: false,
      id_faq: null,
      dadosPergunta: {
        titulo: null,
        conteudo: null,
        classificacao_cliente: true,
        classificacao_posto: true,
        classificacao_frentista: true,
        classificacao_empresa: true
      }
    }
  },
  watch: {
    faq (val) {
      if (val) {
        this.id_faq = this.faq.id_faq
        this.dadosPergunta.titulo = val.titulo
        this.dadosPergunta.conteudo = val.conteudo
        this.dadosPergunta.classificacao_cliente = val.classificacao_cliente
        this.dadosPergunta.classificacao_posto = val.classificacao_posto
        this.dadosPergunta.classificacao_frentista = val.classificacao_frentista
        this.dadosPergunta.classificacao_empresa = val.classificacao_empresa
      }
    }
  },
  computed: {
    faq () {
      return this.$store.getters.faq
    },
    headers () {
      return this.$store.getters.headers
    }
  },
  mounted () {
    if (this.faq) {
      this.id_faq = this.faq.id_faq
      this.dadosPergunta.titulo = this.faq.titulo
      this.dadosPergunta.conteudo = this.faq.conteudo
      this.dadosPergunta.classificacao_cliente = this.faq.classificacao_cliente
      this.dadosPergunta.classificacao_posto = this.faq.classificacao_posto
      this.dadosPergunta.classificacao_frentista = this.faq.classificacao_frentista
      this.dadosPergunta.classificacao_empresa = this.faq.classificacao_empresa
    }
  },
  methods: {
    fechar () {
      this.$refs.formFaq.reset()
      this.$store.dispatch('selectFaq', null)
      this.$emit('fechar')
    },
    atualizarPergunta () {
      if (this.$refs.formFaq.validate()) {
        faqDao.atualizarFaq(this.id_faq, this.dadosPergunta, this.headers)
          .then(response => {
            if (response.ok) {
              this.$emit('info', 'Pergunta atualizada com sucesso')
              this.fechar()
            } else {
              this.$emit('error', 'Não foi possível atualizar a pergunta')
              this.fechar()
            }
          })
      }
    }
  }
}
</script>
